import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";
const options = {role: ROLE.ADVERTISER};
const path = "/advertiser"

export const getDashboardData = async (search) => {
  return await axiosInstance(options).get(`${path}/user/dashboard?search=${search}`);
}












